import axios from "axios";
import {OUT_USER, USER_INFO, USER_LOGIN} from "../../api/api";
import {getToken, removeToken, setToken} from "../../util/auth";

const state = {
  token: getToken(),
  avatar: "",
  nickname: "",
  mobile: "",
  email: "",
}

const mutations = {
  RESET_USER:(state) => {
    state.token = ""
    state.avatar = ""
    state.nickname = ""
    state.mobile = ""
    state.email = ""
    removeToken()
  },
  SET_TOKEN:(state, token) => {
    setToken(token)
    state.token = token
  },
  SET_AVATAR:(state, avatar) => {
    state.avatar = avatar
  },
  SET_NICKNAME:(state, nickname) => {
    state.nickname = nickname
  },
  SET_MOBILE:(state, mobile) => {
    state.mobile = mobile
  },
  SET_EMAIL:(state, email) => {
    state.email = email
  },

}

const actions = {
  loginUser({commit}, userInfo) {
    return new Promise((resolve, reject)=>{
      axios.post(USER_LOGIN, userInfo).then((res)=>{
        if(res.data.code == 1){

          let {userinfo} = res.data.data
          commit('SET_TOKEN', userinfo.token)
          commit('SET_AVATAR', userinfo.avatar)
          commit('SET_NICKNAME', userinfo.nickname)
          commit('SET_MOBILE', userinfo.mobile)
          commit('SET_EMAIL', userinfo.email)
        }
        resolve(res)
      })
    });
  },


  exitUser({commit}, userInfo) {
    return new Promise((resolve, reject)=>{
      axios.post(OUT_USER, userInfo, {
        headers:{"token": getToken()}
      }).then((res)=>{

        if(res.data.code == 1){

          commit('RESET_USER')
        }
        resolve(res)
      })
    });
  },


  getUserInfo({commit}){
    return new Promise((resolve, reject) => {
      axios.get(USER_INFO, {
        headers: { "token": getToken() }
      }).then((res)=>{

        if(res.data.code == 1){
          let {userinfo} = res.data.data
          commit('SET_TOKEN', userinfo.token)
          commit('SET_AVATAR', userinfo.avatar)
          commit('SET_NICKNAME', userinfo.nickname)
          commit('SET_MOBILE', userinfo.mobile)
          commit('SET_EMAIL', userinfo.email)
        }
        resolve(res)

      })
    })

  }
}


export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js